import { useCookies } from "react-cookie"
import { COOKIE_EXPIRATION } from "shared/constant/cookie.constant"

const useLoginCookie = () => {

    const cookieName = "TLC1"
    const [cookie, setCookie, removeCookie] = useCookies([cookieName])

    const createCookie = (token) => {
        setCookie(cookieName, token, {
            "path": "/",
            // "sameSite": "none",
            // "secure": true,
            "expires": new Date(Date.now() + COOKIE_EXPIRATION.ONE_MONTH)
        })
    }

    const deleteCookie = () => {
        removeCookie(cookieName, { "path": "/" })
    }

    return [cookie[cookieName], createCookie, deleteCookie]
}

export default useLoginCookie